export const mergeTagPlaceholder = 'Select a merge tag...';
